import TfLaunch from '@/micro-app/tf-launch';
// import { useAPIQueryGetByType, Type } from '@/apis/goodsPool/getByType';

function Feeds() {
  return <TfLaunch data={{}} />;
}

export default Feeds;
